/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import Component from "@glimmer/component";
export default class FileDownloadAndVisualisation extends Component {
  get fileAttachmentIsAnImage() {
    return this.args.mimeType.substring(0, this.args.mimeType.indexOf("/")) === "image";
  }
  get documentContentWithMimeType() {
    return `data:${this.args.mimeType};base64,${this.args.documentContent}`;
  }
  get iframeTitle() {
    return this.args.iframeTitle || "Document";
  }
}